import { render, staticRenderFns } from "./IndexRotinaInfantil.vue?vue&type=template&id=82b7e032"
import script from "./IndexRotinaInfantil.vue?vue&type=script&lang=js"
export * from "./IndexRotinaInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports